module.exports = __webpack_public_path__ + "img/lidianyou.f7931e8e.png";